import wifiImage from "./images/Functions/wifi.jpg";
import storePlovdiv from "./images/About/storePlovdiv.png";
import consultation from "./images/About/consultation.png";
import prevention from "./images/About/prevention.jpg";
import install from "./images/About/install.png";
import service from "./images/About/service.jpg";
import skf from "./images/About/companies/skf.png";
import kImoti from "./images/About/companies/kImoti.png";
import karlovo from "./images/About/companies/karlovo.png";
import ednoVreme from "./images/About/companies/ednoVreme.png";
import karlovoMes from "./images/About/companies/karlovoMes.png";
import cateringPreslava from "./images/About/companies/cateringPreslava.png";
import accessoryImage from "./images/Accessories/accessoryImage.png"
import accessories from './images/HereFor/accessories.jpg';
import column from './images/HereFor/column.jpg';
import homeAndOffice from './images/HereFor/homeAndOffice.jpg';
import hyperinvertor from './images/HereFor/hyperinvertor.jpg';
import reciklirani from './images/HereFor/reciklirani.jpg';
import multisplit from './images/HereFor/multisplit.png';
import professional from './images/HereFor/professional.png';

export const Assets = {
  Functions: {
    wifi: wifiImage,
  },
  ProductDetails: {},
  ServicesBar: {},
  About: {
    storePlovdiv,
    consultation,
    prevention,
    install,
    service,
    companies:  {
      skf,
      kImoti,
      karlovo,
      ednoVreme,
      karlovoMes,
      cateringPreslava,
    },
  },
  hereFor: {
    accessories,
    column,
    homeAndOffice,
    hyperinvertor,
    reciklirani,
    multisplit,
    professional
  },
  Accessories: {
    accessoryImage
  }
};
